/** UI strings. Product content is localized in D1 (name_es / name_en ...). */
import { marketEn, marketEs } from "./market";
import { buyEn, buyEs } from "./buy";
import { wantedEn, wantedEs } from "./wanted";
export const es = {
  "site.tagline": "Cartas, boxes y accesorios de Pokémon",
  "nav.home": "Inicio",
  "nav.admin": "Admin",
  "currency.label": "Moneda",
  "theme.label": "Tema: {current}. Cambiar a {next}",
  "theme.system": "automático (como el dispositivo)",
  "theme.light": "claro",
  "theme.dark": "oscuro",
  "currency.usd": "Ver precios en dólares",
  "currency.ars": "Ver precios en pesos (dólar blue + 5%)",
  "nav.catalog": "Tienda",
  // While the store sells nothing of its own (the site sells only through the market).
  "closed.nav": "Catálogo",
  "closed.title": "Catálogo",
  "closed.back": "Volver al catálogo",
  "closed.inStock": "Solo lo que se vende en el mercado",
  "closed.noOffers": "Nadie la vende todavía",
  "closed.viewCard": "Ver carta",
  "closed.heroCta": "Ir al mercado",
  "closed.checkout": "Por ahora no vendemos stock propio: todo lo que hay se vende en el mercado, directo de los vendedores.",
  "nav.cart": "Carrito",
  "nav.menu": "Menú",
  "nav.close": "Cerrar",
  "nav.categories": "Categorías",
  "nav.shipping": "Envíos y pagos",
  "nav.help": "Ayuda",
  "nav.shop": "Comprar",
  "nav.wanted": "Se busca",
  "nav.sell": "Vender",
  "nav.allMarket": "Ver todo el mercado",
  "nav.sets": "Expansiones",
  "nav.setCards": "{count} cartas en venta",
  "nav.setCards_one": "1 carta en venta",
  "nav.seeOffers": "Ver ofertas",
  "nav.identify": "Identificar una carta con una foto",
  "nav.wants": "Lo que busco",
  "nav.wantsHint": "Guardá las cartas que buscás y te avisamos cuando alguien las publica.",
  "nav.sellMarket": "Vendé en el mercado",
  "nav.sellMarketHint": "Sin comisión: el comprador te paga directo.",
  "nav.myShop": "Mi tienda",
  "nav.myShopHint": "Tus publicaciones, ventas y estadísticas.",
  "nav.weBuy": "Te compramos tus cartas",
  "nav.weBuyHint": "Mandanos fotos y te pasamos una oferta.",
  "nav.guide": "Guía de compra",
  "nav.faq": "Preguntas frecuentes",
  "nav.refunds": "Devoluciones",
  "nav.withdrawal": "Botón de arrepentimiento",
  "nav.contact": "Contacto",
  "nav.about": "Nosotros",
  "nl.title": "{pct}% off en tu próxima compra",
  "nl.text": "Suscribite a las novedades de pokefans.fun (lanzamientos, preventas y ofertas) y te regalamos un código del {pct}% de descuento.",
  "nl.subscribe": "Suscribirme y recibir mi {pct}%",
  "nl.register": "Crear mi cuenta y recibir el {pct}%",
  "nl.haveAccount": "¿Ya tenés cuenta?",
  "nl.terms": "Código personal de un solo uso, válido {days} días. Te podés dar de baja cuando quieras.",
  "nl.later": "Ahora no",
  "nl.doneTitle": "¡Listo, ya estás suscripto!",
  "nl.doneText": "Este es tu código del {pct}%. Ingresalo al pagar. También te lo mandamos por mail.",
  "nl.fine": "Personal y de un solo uso, válido hasta el {days}.",
  "nl.shop": "Ir a la tienda",
  "nl.excluded": "No aplica a: {list}.",
  "nl.pending": "Te mandamos el código por mail en unos minutos.",
  "nl.accountCoupon": "Tu código de bienvenida: {code} ({pct}% off, válido hasta el {date}).",
  "nl.accountUsed": "Ya usaste tu código de bienvenida {code}.",
  "ship.title": "Calculá el envío",
  "ship.placeholder": "Código postal",
  "ship.calculate": "Calcular",
  "ship.invalid": "Ingresá un código postal válido, por ejemplo 1425 o C1425DKP.",
  "ship.caba": "Envío a CABA: {price}.",
  "ship.gba": "Envío al Gran Buenos Aires: {price}.",
  "ship.gbaRange": "Envío al Gran Buenos Aires: entre {min} y {max} según tu localidad. Te mostramos el costo exacto al pagar.",
  "ship.country": "Envío por correo: {price}.",
  "ship.arrange": "Para tu zona coordinamos el envío (costo y plazo) por WhatsApp.",
  "ship.freeFrom": "Gratis en compras desde {min}.",
  "ship.pickup": "Retiro sin cargo en {area}.",
  "perks.label": "Beneficios",
  "perks.freeShipping": "Envío gratis en {zones}",
  "perks.freeShippingMin": "en compras desde {min}",
  "perks.transfer": "Mejor precio por transferencia",
  "perks.transferSub": "o pagá con Mercado Pago",
  "perks.payments": "Transferencia o Mercado Pago",
  "perks.paymentsSub": "elegís al pagar",
  "perks.pickup": "Retiro sin cargo en {area}",
  "perks.pickupSub": "coordinamos por WhatsApp",
  "perks.stock": "Stock real",
  "perks.stockSub": "estado de cada carta indicado",
  "lang.label": "Idioma",
  "game.label": "Juego de cartas",
  "lang.es": "Español",
  "lang.en": "English",
  "search.placeholder": "Buscá cartas, productos o vendedores…",
  "catalog.fuzzy": "No encontramos \"{q}\" tal cual; te mostramos resultados parecidos.",
  "search.suggestions": "Sugerencias",
  "search.fromSellers": "desde {price} en vendedores",
  "search.noStock": "Sin stock",
  "search.seeAll": "Ver todos los resultados de \"{q}\"",
  "search.label": "Buscar",
  "search.submit": "Buscar",
  "home.heroTitle": "Tu próxima apertura empieza acá",
  "home.heroText": "Booster boxes, Elite Trainer Boxes, sobres y cartas sueltas de Pokémon TCG.",
  "cookies.title": "Cookies",
  "cookies.text": "Usamos Google Analytics para saber qué partes del sitio se usan y mejorarlo. Podés rechazarlo acá o desde el pie de página.",
  "cookies.more": "Política de cookies",
  "cookies.accept": "Entendido",
  "cookies.reject": "Rechazar",
  "cookies.settings": "Configurar cookies",
  "whatsapp.label": "Escribinos por WhatsApp",
  "whatsapp.message": "Hola! Tengo una consulta",
  "whatsapp.buyButton": "Comprar por WhatsApp",
  "whatsapp.askStockButton": "Consultar por WhatsApp",
  "whatsapp.buy": "¡Hola! Quiero {product} a {price}. {link}",
  "whatsapp.buyMany": "¡Hola! Quiero {quantity} × {product} a {price} c/u. {link}",
  "whatsapp.askStock": "¡Hola! ¿Van a volver a tener {product}? {link}",
  "banner.label": "Novedades de la tienda",
  "banner.slide": "{n} de {total}",
  "banner.prev": "Banner anterior",
  "banner.next": "Banner siguiente",
  "banner.goTo": "Ir al banner {n}",
  "banner.pause": "Pausar los banners",
  "banner.play": "Pasar los banners solos",
  "banner.presale": "Preventa",
  "banner.releases": "Sale el {date}",
  "product.presale": "Preventa",
  "product.presaleNote": "Preventa: sale el {date}. Lo pagás ahora y te lo enviamos apenas llegue.",
  "product.presaleNoteNoDate": "Preventa: lo pagás ahora y te lo enviamos apenas llegue.",
  "product.reserve": "Reservar en preventa",
  "cart.presaleNote": "Tu pedido incluye productos en preventa: lo despachamos completo cuando lleguen. Si querés recibir antes lo demás, hacé dos pedidos.",
  "catalog.presaleOnly": "Solo preventas",
  "home.newArrivals": "Recién llegado",
  "home.newArrivalsAll": "Ver todas las novedades",
  "home.sets": "Más colecciones",
  "home.setsCount": "{count} a la venta",
  "home.setsAll": "Ver todas las colecciones ({count})",
  "home.sealed": "Sellados",
  "home.sealedAll": "Ver todos",
  "home.sealed.packs": "Sobres",
  "home.sealed.boxes": "Cajas, colecciones y mazos",
  "home.sealed.etb": "Elite Trainer Box",
  "home.sealedEmpty": "Nadie vende de estos ahora. Volvé pronto.",
  "home.featured": "Destacados",
  "home.byCategory": "Comprá por categoría",
  "home.viewAll": "Ver todo",
  "catalog.title": "Tienda",
  "catalog.results": "{count} productos",
  "catalog.results_one": "1 producto",
  "catalog.empty": "No encontramos productos con esos filtros.",
  "catalog.clearFilters": "Limpiar filtros",
  "catalog.filters": "Filtros",
  "catalog.showFilters": "Filtrar ({count})",
  "catalog.applyFilters": "Ver resultados",
  "catalog.searchFor": "Resultados para “{q}”",
  "filters.game": "Juego",
  "filters.category": "Categoría",
  "filters.price": "Precio",
  "filters.set": "Expansión",
  "filters.setSearch": "Buscá una expansión (ej: Surging, SSP)…",
  "filters.noMatches": "Sin coincidencias",
  "filters.rarity": "Rareza",
  "filters.showAll": "Mostrar todos ({count})",
  "filters.showLess": "Ver menos",
  "filters.min": "Mínimo",
  "filters.max": "Máximo",
  "filters.apply": "Aplicar",
  "filters.inStock": "Solo disponibles (tienda o vendedores)",
  "filters.withOutOfStock": "Incluye sin stock",
  "filters.active": "Filtros activos",
  "filters.remove": "Quitar filtro: {label}",
  "sort.label": "Ordenar por",
  "sort.featured": "Destacados",
  "sort.newest": "Más nuevos",
  "sort.price_asc": "Precio: menor a mayor",
  "sort.price_desc": "Precio: mayor a menor",
  "sort.name_asc": "Nombre: A-Z",
  "pagination.label": "Paginación",
  "pagination.prev": "Anterior",
  "pagination.next": "Siguiente",
  "pagination.page": "Página {page}",
  "product.addToCart": "Agregar al carrito",
  "product.added": "¡Agregado!",
  "product.outOfStock": "Sin stock",
  "product.lowStock": "¡Últimas {count} unidades!",
  "product.lowStock_one": "¡Última unidad!",
  "product.inStock": "En stock",
  "product.quantity": "Cantidad",
  "product.sku": "SKU",
  "product.language": "Idioma",
  "product.set": "Expansión",
  "product.number": "Número",
  "product.rarity": "Rareza",
  "product.condition": "Estado",
  "product.finish": "Terminación",
  "product.contents": "Qué trae",
  "product.setCards": "Cartas que pueden salir",
  "product.setCardsIntro": "La expansión {set} tiene {count} cartas. Estas son las más buscadas a la venta:",
  "product.setCardsIntroMany": "Las expansiones {sets} tienen {count} cartas. Estas son las más buscadas a la venta:",
  "product.setCardsAll": "Ver las de la expansión en el mercado",
  "product.related": "También te puede interesar",
  "product.notFound": "No encontramos este producto.",
  "product.sale": "Oferta",
  "product.back": "Volver a la tienda",
  "product.backMarket": "Volver al mercado",
  "product.chooseOption": "Elegir opción",
  "product.from": "Desde",
  "product.transferPrice": "{price} con transferencia",
  "product.version": "Versión",
  "product.versionStock": "{count} disponibles",
  "product.versionStock_one": "1 disponible",
  "printLang.es": "Español",
  "printLang.en": "Inglés",
  "printLang.ja": "Japonés",
  "cart.title": "Tu carrito",
  "cart.empty": "Tu carrito está vacío.",
  "cart.continue": "Seguir comprando",
  "cart.subtotal": "Subtotal",
  "cart.checkout": "Finalizar compra",
  "cart.remove": "Quitar",
  "cart.decrease": "Restar uno",
  "cart.increase": "Sumar uno",
  "cart.items": "{count} artículos",
  "cart.items_one": "1 artículo",
  "cart.maxStock": "Máximo disponible: {count}",
  "cart.open": "Abrir carrito ({count})",
  "checkout.title": "Finalizar compra",
  "checkout.contact": "Datos de contacto",
  "checkout.name": "Nombre y apellido",
  "checkout.email": "Email",
  "checkout.phone": "Teléfono / WhatsApp",
  "checkout.city": "Ciudad / Provincia",
  "checkout.notes": "Notas (opcional)",
  "checkout.delivery": "Entrega",
  "checkout.pickup": "Retiro en punto de entrega",
  "checkout.pickupHint": "Gratis · {area}. Te pasamos la dirección por WhatsApp después de comprar.",
  "checkout.pickupNote": "Después de pagar te escribimos por WhatsApp con la dirección exacta y los horarios para retirar.",
  "checkout.shipping": "Envío a domicilio",
  "checkout.address": "Dirección de entrega (calle, número, piso, CP)",
  "checkout.errors.address": "Ingresá la dirección de entrega.",
  "checkout.phoneHint": "Te escribimos por WhatsApp a este número para coordinar la entrega.",
  "checkout.freeShipping": "¡Tu compra tiene envío gratis! La despachamos dentro de las {hours} horas.",
  "checkout.zone": "Zona de entrega",
  "checkout.zoneChoose": "Elegí tu zona",
  "checkout.zoneFast": "Envío {price}. Lo despachamos dentro de las {hours} horas.",
  "checkout.zoneArrange": "a coordinar",
  "checkout.subtotal": "Productos",
  "checkout.shippingRow": "Envío",
  "checkout.shippingChooseZone": "Elegí la zona",
  "checkout.shippingArrange": "A coordinar por WhatsApp",
  "checkout.shippingFree": "Gratis",
  "checkout.zoneOther": "Para tu zona coordinamos el envío (costo y plazo) por WhatsApp.",
  "checkout.zoneOtherRate": "Envío por correo a todo el país: {price}. Te mandamos el número de seguimiento al despacharlo.",
  "checkout.freeFrom": "Envío gratis en compras desde {min}.",
  "checkout.errors.zone": "Elegí la zona de entrega.",
  "checkout.errors.zoneMismatch": "La zona no corresponde a la ciudad elegida: elegí la zona de tu ciudad.",
  "checkout.steps": "Pasos de la compra",
  "checkout.step1": "Tus datos",
  "checkout.step2": "Envío o retiro",
  "checkout.step3": "Pago",
  "checkout.continue": "Continuar",
  "checkout.back": "Volver",
  "checkout.emailHint": "Te mandamos ahí la confirmación y el link para seguir tu pedido.",
  "checkout.guestHint": "Podés comprar sin cuenta.",
  "checkout.guestLogin": "¿Tenés cuenta? Ingresá para usar tus datos guardados.",
  "checkout.errors.openOrders": "Tenés varios pedidos sin pagar con este email. Pagá alguno o esperá a que venzan para hacer otro.",
  "checkout.packaging": "Cada carta viaja en su sleeve (funda), y las de más de US$ 10 además en un toploader rígido, para que no se doblen ni se ensucien.",
  "checkout.summary": "Resumen del pedido",
  "checkout.total": "Total",
  "checkout.submit": "Confirmar pedido",
  "checkout.submitting": "Enviando...",
  "checkout.successTitle": "¡Pedido recibido!",
  "checkout.successText": "Tu número de pedido es {number}. Te vamos a contactar para coordinar pago y envío.",
  "checkout.errors.invalid": "Revisá los datos del formulario.",
  "checkout.errors.name": "Ingresá tu nombre.",
  "checkout.errors.email": "Ingresá un email válido.",
  "checkout.errors.phone": "Ingresá un teléfono válido.",
  "checkout.errors.city": "Ingresá tu ciudad.",
  "checkout.errors.delivery": "Elegí un método de entrega.",
  "checkout.errors.empty": "Tu carrito está vacío.",
  "checkout.errors.tooMany": "Demasiados productos en un solo pedido.",
  "checkout.errors.items": "Hay productos inválidos en el carrito.",
  "checkout.errors.stock": "Algunos productos ya no tienen stock suficiente. Revisá tu carrito.",
  "checkout.errors.network": "No pudimos enviar el pedido. Probá de nuevo en unos minutos.",
  "error.generic": "Algo salió mal. Probá de nuevo.",
  "error.retry": "Reintentar",
  "loading": "Cargando...",
  "notFound.title": "Página no encontrada",
  "notFound.back": "Volver al inicio",
  "footer.rights": "© {year} pokefans.fun. Todos los derechos reservados.",
  "footer.disclaimer":
    "pokefans.fun es una tienda independiente, no afiliada a The Pokémon Company. Pokémon y sus nombres son marcas de Nintendo, Creatures y GAME FREAK.",
  "footer.contact": "Contacto",
  "footer.legal": "Legal",
  "footer.resources": "Recursos",
  "footer.refunds": "Política de reembolsos",
  "footer.withdraw": "Botón de arrepentimiento",
  "withdraw.title": "Botón de arrepentimiento",
  "withdraw.intro": "Si compraste en pokefans.fun, tenés 10 días corridos desde que recibiste el producto para arrepentirte de la compra, sin dar explicaciones (Ley 24.240, art. 34). Completá el formulario y te damos un código de trámite en el momento.",
  "withdraw.more": "El envío de vuelta corre por nuestra cuenta y te reintegramos por el mismo medio de pago. Más detalles en la",
  "withdraw.order": "Número de pedido",
  "withdraw.orderHint": "Está en el email de confirmación y en Mi cuenta.",
  "withdraw.name": "Nombre y apellido",
  "withdraw.email": "Email con el que compraste",
  "withdraw.phone": "Teléfono (opcional)",
  "withdraw.reason": "Motivo (opcional)",
  "withdraw.submit": "Enviar pedido de arrepentimiento",
  "withdraw.sending": "Enviando…",
  "withdraw.doneTitle": "Recibimos tu pedido de arrepentimiento",
  "withdraw.doneCode": "Tu código de trámite es:",
  "withdraw.doneText": "También te lo mandamos por email. Te contactamos dentro de las 48 horas con los pasos para la devolución.",
  "withdraw.notFound": "No encontramos un pedido con ese número y email, pero registramos tu pedido igual: lo revisamos y te contactamos.",
  "withdraw.errors.order": "Ingresá el número de pedido.",
  "footer.consumer": "Defensa de las y los consumidores. Para reclamos ingresá acá.",
  "legal.updated": "Última actualización: {date}",
  "soon.pill": "En construcción",
  "soon.title": "¡Próximamente!",
  "soon.text": "Estamos armando la tienda de cartas, boxes y accesorios de Pokémon TCG. Muy pronto vas a poder comprar online.",
  "soon.point1": "Cartas sueltas y producto sellado de Pokémon TCG",
  "soon.point2": "Pagos con Mercado Pago, tarjeta y PayPal",
  "soon.point3": "Envíos a todo el país",
  "soon.cta": "Mirar el mercado",
  "soon.strip": "La tienda todavía no toma pedidos. Podés recorrer el catálogo.",
  "soon.button": "Próximamente",
  "soon.previewTitle": "Modo prueba",
  "soon.previewText": "Estás viendo la tienda completa como invitado; todavía no está abierta al público.",

  "auth.login": "Ingresar",
  "auth.logout": "Cerrar sesión",
  "auth.account": "Mi cuenta",
  "auth.loginTitle": "Ingresá a tu cuenta",
  "auth.registerTitle": "Creá tu cuenta",
  "auth.forgotTitle": "Recuperar contraseña",
  "auth.resetTitle": "Elegí una nueva contraseña",
  "auth.shopInviteTitle": "Elegí tu contraseña para entrar a tu tienda",
  "auth.name": "Nombre",
  "auth.email": "Email",
  "auth.password": "Contraseña",
  "auth.newPassword": "Nueva contraseña",
  "auth.passwordHint": "Mínimo 8 caracteres.",
  "auth.showPassword": "Mostrar",
  "auth.hidePassword": "Ocultar",
  "auth.submitLogin": "Ingresar",
  "auth.submitRegister": "Crear cuenta",
  "auth.submitForgot": "Enviar enlace",
  "auth.submitReset": "Guardar contraseña",
  "auth.working": "Procesando...",
  "auth.google": "Continuar con Google",
  "auth.or": "o",
  "auth.noAccount": "¿No tenés cuenta?",
  "auth.haveAccount": "¿Ya tenés cuenta?",
  "auth.forgotLink": "¿Olvidaste tu contraseña?",
  "auth.backToLogin": "Volver a ingresar",
  "auth.checkEmailTitle": "Revisá tu email",
  "auth.checkEmailText": "Te enviamos un enlace a {email} para confirmar tu cuenta. Después vas a poder ingresar.",
  "auth.forgotSent": "Si existe una cuenta con {email}, te enviamos un enlace para restablecer la contraseña.",
  "auth.resetDone": "Listo, tu contraseña fue actualizada. Ya podés ingresar.",
  "auth.resendVerification": "Reenviar email de verificación",
  "auth.verificationResent": "Te reenviamos el email de verificación.",
  "auth.errorSummary": "Revisá estos datos:",
  "auth.errors.name": "Ingresá tu nombre.",
  "auth.errors.email": "Ingresá un email válido.",
  "auth.errors.password": "La contraseña debe tener al menos 8 caracteres.",
  "auth.errors.invalidCredentials": "Email o contraseña incorrectos.",
  "auth.errors.notVerified": "Tenés que confirmar tu email antes de ingresar.",
  "auth.errors.userExists": "Ya existe una cuenta con ese email: ingresá con ella (o recuperá tu contraseña).",
  "auth.errors.invalidToken": "El enlace no es válido o venció. Pedí uno nuevo.",
  "auth.errors.tooMany": "Demasiados intentos. Esperá un minuto y probá de nuevo.",
  "auth.errors.generic": "No pudimos completar la operación. Probá de nuevo.",
  "auth.marketingOptIn": "Quiero recibir avisos de ofertas, reposiciones y bajas de precio por email (me puedo dar de baja cuando quiera).",
  "auth.acceptTerms": "Al crear tu cuenta aceptás los",
  "auth.termsLink": "Términos y condiciones",
  "auth.privacyLink": "Política de privacidad",
  "profile.title": "Mis datos",
  "profile.firstName": "Nombre",
  "profile.lastName": "Apellido",
  "profile.phone": "Teléfono",
  "profile.address": "Dirección de entrega",
  "profile.addressLine": "Calle y número, piso, depto",
  "profile.city": "Ciudad o localidad",
  "profile.province": "Provincia",
  "profile.postalCode": "Código postal",
  "profile.save": "Guardar mis datos",
  "profile.saved": "Guardamos tus datos.",
  "profile.error": "No pudimos guardar. Revisá los datos.",
  "profile.avatar": "Foto de perfil",
  "profile.avatarChange": "Cambiar foto",
  "profile.avatarRemove": "Quitar foto",
  "profile.avatarError": "No pudimos usar esa imagen: probá con otra JPG, PNG o WebP.",
  "profile.emails": "Emails",
  "profile.marketing": "Recibir avisos de ofertas, reposiciones y bajas de precio",
  "profile.marketingHint": "Los emails de tus pedidos y de tu cuenta te llegan igual.",
  "profile.errors.firstName": "Ingresá tu nombre.",
  "profile.errors.phone": "Ingresá un teléfono válido.",
  "unsubscribe.title": "Darte de baja de los emails",
  "unsubscribe.text": "Vas a dejar de recibir avisos de ofertas y novedades. Los emails de tus pedidos te van a seguir llegando.",
  "unsubscribe.button": "Darme de baja",
  "unsubscribe.done": "Listo: no te vamos a mandar más emails de ofertas. Podés volver a activarlos desde Mi cuenta.",
  "unsubscribe.invalid": "El link no es válido o está incompleto.",
  "address.province": "Provincia",
  "address.city": "Ciudad o localidad",
  "address.barrio": "Barrio",
  "address.chooseProvince": "Escribí o elegí la provincia",
  "address.provinceFirst": "Primero elegí la provincia",
  "address.typeCity": "Escribí para buscar",
  "address.noProvince": "No hay una provincia con ese nombre.",
  "address.noCity": "No la encontramos en la lista: podés dejarla escrita así.",
  "address.line1": "Calle y número",
  "address.line2": "Piso, depto, entre calles u otras indicaciones (opcional)",
  "address.postalCode": "Código postal",
  "checkout.errors.place": "Elegí la provincia y la ciudad.",
  "watch.stock": "Avisame cuando haya stock",
  "watch.price": "Avisame si baja de precio",
  "watch.stockOn": "Te avisamos por email cuando vuelva a haber stock.",
  "watch.priceOn": "Te avisamos por email si baja de precio.",
  "watch.priceOnTarget": "Te avisamos por email si baja a {price} o menos.",
  "watch.cancel": "Cancelar aviso",
  "watch.targetLabel": "¿A qué precio? (opcional, en US$)",
  "watch.targetPlaceholder": "Cualquier baja",
  "watch.create": "Crear aviso",
  "watch.errors.target": "Ingresá un precio menor al actual (por ejemplo 12,50).",
  "watch.title": "Mis avisos",
  "watch.empty": "No tenés avisos. En cada producto podés pedir que te avisemos cuando haya stock o baje de precio.",
  "watch.kindStock": "Cuando haya stock",
  "watch.kindPrice": "Si baja de precio",
  "watch.kindPriceTarget": "Si baja a {price}",
  "auth.twoFactor.needed": "Ingresá el código de tu app de autenticación.",
  "auth.twoFactor.invalid": "El código no es válido o venció. Probá con el nuevo.",
  "auth.twoFactor.title": "Verificación en dos pasos",
  "auth.twoFactor.code": "Código de 6 dígitos",
  "auth.twoFactor.backupCode": "Código de respaldo",
  "auth.twoFactor.useBackup": "Usar un código de respaldo",
  "auth.twoFactor.useApp": "Usar la app de autenticación",
  "auth.twoFactor.trust": "Confiar en este dispositivo por 30 días",
  "auth.twoFactor.submit": "Verificar",
  "auth.errors.google": "No pudimos ingresar con Google. Probá de nuevo.",
  "auth.errors.comingSoon": "Todavía no abrimos: por ahora solo pueden ingresar las cuentas de prueba.",
  "auth.errors.invitesOnly": "La tienda todavía no abrió: por ahora solo pueden ingresar cuentas invitadas.",
  "account.title": "Mi cuenta",
  "account.hello": "Hola, {name}",
  "account.orders": "Mis pedidos",
  "cards.title": "Mi colección",
  "cards.level": "Nivel {level} de {max}",
  "cards.levelShort": "Nivel {level}",
  "cards.generation": "Generación {gen}",
  "cards.chooseTitle": "Elegí tu Pokémon inicial",
  "cards.chooseIntro": "Tu avatar es una carta real que evoluciona: con cada hito (verificar tu email, tu primera compra, envío gratis…) sube un nivel y se vuelve más rara, hasta la dorada.",
  "cards.changeIntro": "Elegí otro inicial: mantenés tu nivel, cambian las cartas.",
  "cards.picking": "Eligiendo…",
  "cards.pickError": "No se pudo guardar. Probá de nuevo.",
  "cards.later": "Más tarde",
  "cards.cancel": "Cancelar",
  "cards.evolving": "¿Qué? ¡Tu carta está evolucionando!",
  "cards.levelUp": "¡Subiste al nivel {level}!",
  "cards.great": "¡Genial!",
  "cards.useCard": "Usar mi carta como avatar",
  "cards.usePhoto": "Usar mi foto",
  "cards.useLatest": "Usar siempre la última",
  "cards.useThis": "Usar como avatar",
  "cards.changeStarter": "Cambiar inicial",
  "cards.locked": "Nivel {level}: bloqueada",
  "cards.milestones": "Hitos: {done} de {total}",
  "cards.done": "cumplido",
  "account.noOrders": "Todavía no hiciste pedidos.",
  "account.viewOrder": "Ver pedido",
  "checkout.accountEmail": "Vamos a usar el email de tu cuenta: {email}",
  "checkout.payment": "Medio de pago",
  "checkout.pay.mercadopago": "Mercado Pago",
  "checkout.pay.mercadopagoHint": "Tarjetas, dinero en cuenta y más. Se cobra en pesos: {amount}.",
  "checkout.pay.stripe": "Tarjeta de crédito o débito (Stripe)",
  "checkout.pay.stripeHint": "Se cobra en dólares: {amount}.",
  "checkout.pay.paypal": "PayPal",
  "checkout.pay.paypalHint": "Se cobra en dólares: {amount}.",
  "checkout.pay.transfer": "Transferencia bancaria",
  "checkout.pay.transferHint": "Precio especial sin la comisión de Mercado Pago: pagás {amount}. Mandás el comprobante por WhatsApp y te reservamos el stock 2 horas.",
  "checkout.pay.crypto": "Cripto (USDT)",
  "checkout.pay.cryptoHint": "{discount}% de descuento: pagás {amount} en USDT. Mandás el comprobante por WhatsApp y te reservamos el stock 2 horas.",
  "order.manual.title": "Cómo pagar",
  "order.manual.intro": "Te reservamos los productos hasta las {deadline}. Pagá con estos datos:",
  "order.manual.amount": "Monto exacto",
  "order.manual.holder": "Titular",
  "order.manual.bank": "Banco",
  "order.manual.network": "Red",
  "order.manual.networkWarn": "Enviá solo por la red indicada: un envío por otra red se pierde.",
  "order.manual.discount": "Incluye el {discount}% de descuento.",
  "order.manual.transferPrice": "Es el precio especial por transferencia (sin la comisión de Mercado Pago).",
  "order.manual.send": "Cuando pagues, mandanos el comprobante por WhatsApp con tu número de pedido. Confirmamos el pago y te avisamos por email.",
  "order.manual.sendEmail": "Cuando pagues, mandanos el comprobante respondiendo el email que te enviamos, con tu número de pedido.",
  "order.manual.whatsapp": "Mandar el comprobante por WhatsApp",
  "order.manual.copy": "Copiar",
  "order.manual.copied": "Copiado",
  "order.manual.expired": "La reserva venció. Si ya pagaste, mandanos el comprobante igual y lo revisamos.",
  "checkout.pay.none": "No hay medios de pago disponibles en este momento.",
  "order.coupon": "Cupón {code}",
  "checkout.coupon.label": "¿Tenés un cupón?",
  "checkout.coupon.apply": "Aplicar",
  "checkout.coupon.remove": "Quitar cupón",
  "checkout.coupon.applied": "Cupón {code}: {amount} de descuento",
  "checkout.coupon.someExcluded": "No aplica a algunos productos de tu carrito.",
  "checkout.coupon.invalid": "Ese código no es válido.",
  "checkout.coupon.not_found": "No encontramos ese cupón.",
  "checkout.coupon.inactive": "Ese cupón ya no está activo.",
  "checkout.coupon.not_started": "Ese cupón todavía no empezó.",
  "checkout.coupon.expired": "Ese cupón ya venció.",
  "checkout.coupon.exhausted": "Ese cupón ya se usó todas las veces posibles.",
  "checkout.coupon.already_used": "Ya usaste este cupón.",
  "checkout.coupon.personal": "Este código es personal: funciona solo en la cuenta que lo recibió.",
  "checkout.coupon.email": "Completá tu email en el paso 1 para usar un cupón.",
  "checkout.coupon.not_applicable": "Ese cupón no aplica a los productos de tu carrito.",
  "checkout.coupon.min_not_reached": "Tu compra no llega al mínimo de este cupón.",
  "checkout.pay.arsNote": "En pesos: dólar blue ({rate}) + 5% con Mercado Pago; por transferencia, sin la comisión de Mercado Pago.",
  "checkout.chargedAs": "Se cobra: {amount}",
  "checkout.submitPay": "Ir a pagar",
  "checkout.redirecting": "Te estamos llevando al medio de pago...",
  "checkout.errors.payment": "Elegí un medio de pago.",
  "checkout.errors.paymentProvider": "No pudimos iniciar el pago. Probá con otro medio.",
  "order.title": "Pedido {number}",
  "order.status.unpaid": "Esperando el pago",
  "order.status.pending": "Pago en proceso",
  "order.status.paid": "¡Pago aprobado!",
  "order.status.failed": "El pago no se completó",
  "order.status.expired": "La reserva venció",
  "order.status.refunded": "Pago reintegrado",
  "order.text.unpaid": "Todavía no recibimos la confirmación del pago. Si ya pagaste, esperá unos segundos.",
  "order.text.manual": "Esperamos tu pago. Cuando nos mandes el comprobante y lo confirmemos, te avisamos por email.",
  "order.text.pending": "El medio de pago está procesando la operación. Te avisamos por email cuando se acredite.",
  "order.text.paid": "Gracias por tu compra. Te vamos a contactar para coordinar la entrega.",
  "order.text.failed": "El pago fue rechazado o cancelado. Los productos volvieron al stock.",
  "order.text.expired": "Pasaron {minutes} minutos sin confirmar el pago y liberamos los productos.",
  "order.text.refunded": "El pago fue devuelto.",
  "order.cancelled": "Cancelaste el pago. Podés volver a intentarlo desde la tienda.",
  "order.charged": "Cobrado: {amount}",
  "order.payAgain": "Volver a la tienda",
  "order.accountTitle": "¿Te creás una cuenta?",
  "order.accountText": "Con tu email {email}, en un minuto. Este pedido aparece en tu cuenta apenas lo verifiques.",
  "order.accountPerk1": "Seguí todos tus pedidos desde Mi cuenta.",
  "order.accountPerk2": "Tus datos y tu dirección quedan guardados para la próxima.",
  "order.accountPerk3": "Suscribite a las novedades y te regalamos un {pct}% para tu próxima compra.",
  "order.accountCta": "Crear mi cuenta",
  "order.accountHave": "Ya tengo cuenta",
  "order.guestNote": "Te mandamos todo por email. Para ver tus pedidos cuando quieras, iniciá sesión con la cuenta con la que compraste.",
  "order.checking": "Verificando el pago...",
  "order.date": "Fecha",
  "order.items": "Productos",

  "identificar_titulo": "Identificar carta",
  "identificar_desc": "Sacale una foto a la carta para buscarla en el catálogo.",
  "abrir_camara": "Abrir cámara",
  "subir_foto": "Subir foto",
  "install.title": "Instalá pokefans",
  "install.body": "Abrila como app desde tu pantalla de inicio.",
  "install.ios": "Tocá Compartir y después \"Agregar a inicio\".",
  "install.button": "Instalar",
  "sacar_foto": "Sacar foto",
  "cancelar": "Cancelar",
  "identificar_accion": "Identificar carta",
  "buscando": "Buscando…",
  "tomar_otra": "Tomar otra",
  "procesando": "Procesando imagen…",
  "resultados": "Resultados",
  ...marketEs,
  ...buyEs,
  ...wantedEs,
} as const;

export type MessageKey = keyof typeof es;

export const en: Record<MessageKey, string> = {
  "site.tagline": "Pokémon cards, boxes and accessories",
  "nav.home": "Home",
  "nav.admin": "Admin",
  "currency.label": "Currency",
  "theme.label": "Theme: {current}. Switch to {next}",
  "theme.system": "automatic (like the device)",
  "theme.light": "light",
  "theme.dark": "dark",
  "currency.usd": "Show prices in US dollars",
  "currency.ars": "Show prices in Argentine pesos (dólar blue + 5%)",
  "nav.catalog": "Shop",
  "closed.nav": "Catalog",
  "closed.title": "Catalog",
  "closed.back": "Back to the catalog",
  "closed.inStock": "Only what the market sells",
  "closed.noOffers": "Nobody sells it yet",
  "closed.viewCard": "View card",
  "closed.heroCta": "Go to the market",
  "closed.checkout": "We're not selling our own stock for now: everything is sold in the market, straight from the sellers.",
  "nav.cart": "Cart",
  "nav.menu": "Menu",
  "nav.close": "Close",
  "nav.categories": "Categories",
  "nav.shipping": "Shipping & payment",
  "nav.help": "Help",
  "nav.shop": "Buy",
  "nav.wanted": "Wanted",
  "nav.sell": "Sell",
  "nav.allMarket": "See the whole market",
  "nav.sets": "Sets",
  "nav.setCards": "{count} cards for sale",
  "nav.setCards_one": "1 card for sale",
  "nav.seeOffers": "See offers",
  "nav.identify": "Identify a card from a photo",
  "nav.wants": "Cards I'm looking for",
  "nav.wantsHint": "Save the cards you want and we'll tell you when someone lists them.",
  "nav.sellMarket": "Sell in the market",
  "nav.sellMarketHint": "No fees: the buyer pays you directly.",
  "nav.myShop": "My shop",
  "nav.myShopHint": "Your listings, sales and stats.",
  "nav.weBuy": "We buy your cards",
  "nav.weBuyHint": "Send us photos and we'll make you an offer.",
  "nav.guide": "Buying guide",
  "nav.faq": "FAQ",
  "nav.refunds": "Returns",
  "nav.withdrawal": "Cancel a purchase",
  "nav.contact": "Contact",
  "nav.about": "About us",
  "nl.title": "{pct}% off your next order",
  "nl.text": "Subscribe to pokefans.fun news (new sets, pre-orders and deals) and get a {pct}% discount code.",
  "nl.subscribe": "Subscribe and get my {pct}%",
  "nl.register": "Create my account and get {pct}%",
  "nl.haveAccount": "Already have an account?",
  "nl.terms": "Personal single-use code, valid for {days} days. Unsubscribe any time.",
  "nl.later": "Not now",
  "nl.doneTitle": "Done, you're subscribed!",
  "nl.doneText": "Here's your {pct}% code. Enter it at checkout. We also emailed it to you.",
  "nl.fine": "Personal and single-use, valid until {days}.",
  "nl.shop": "Go to the shop",
  "nl.excluded": "Not valid on: {list}.",
  "nl.pending": "We'll email you the code in a few minutes.",
  "nl.accountCoupon": "Your welcome code: {code} ({pct}% off, valid until {date}).",
  "nl.accountUsed": "You already used your welcome code {code}.",
  "ship.title": "Shipping cost",
  "ship.placeholder": "Postal code",
  "ship.calculate": "Calculate",
  "ship.invalid": "Enter a valid postal code, e.g. 1425 or C1425DKP.",
  "ship.caba": "Shipping to Buenos Aires City: {price}.",
  "ship.gba": "Shipping to Greater Buenos Aires: {price}.",
  "ship.gbaRange": "Shipping to Greater Buenos Aires: {min} to {max} depending on your town. You'll see the exact cost at checkout.",
  "ship.country": "Shipping by post: {price}.",
  "ship.arrange": "For your area we arrange the shipping (cost and timing) on WhatsApp.",
  "ship.freeFrom": "Free on orders from {min}.",
  "ship.pickup": "Free pickup in {area}.",
  "perks.label": "Why shop here",
  "perks.freeShipping": "Free shipping in {zones}",
  "perks.freeShippingMin": "on orders from {min}",
  "perks.transfer": "Best price by bank transfer",
  "perks.transferSub": "or pay with Mercado Pago",
  "perks.payments": "Bank transfer or Mercado Pago",
  "perks.paymentsSub": "choose at checkout",
  "perks.pickup": "Free pickup in {area}",
  "perks.pickupSub": "arranged on WhatsApp",
  "perks.stock": "Real stock",
  "perks.stockSub": "every card's condition listed",
  "lang.label": "Language",
  "game.label": "Card game",
  "lang.es": "Español",
  "lang.en": "English",
  "search.placeholder": "Search cards, products or sellers…",
  "catalog.fuzzy": "We didn't find \"{q}\" as typed; here are similar results.",
  "search.suggestions": "Suggestions",
  "search.fromSellers": "from {price} at sellers",
  "search.noStock": "Out of stock",
  "search.seeAll": "See all results for \"{q}\"",
  "search.label": "Search",
  "search.submit": "Search",
  "home.heroTitle": "Your next opening starts here",
  "home.heroText": "Booster boxes, Elite Trainer Boxes, packs and single cards for Pokémon TCG.",
  "cookies.title": "Cookies",
  "cookies.text": "We use Google Analytics to learn which parts of the site are used and improve it. You can reject it here or from the footer.",
  "cookies.more": "Cookie policy",
  "cookies.accept": "Got it",
  "cookies.reject": "Reject",
  "cookies.settings": "Cookie settings",
  "whatsapp.label": "Chat with us on WhatsApp",
  "whatsapp.message": "Hi! I have a question",
  "whatsapp.buyButton": "Buy on WhatsApp",
  "whatsapp.askStockButton": "Ask on WhatsApp",
  "whatsapp.buy": "Hi! I'd like {product} at {price}. {link}",
  "whatsapp.buyMany": "Hi! I'd like {quantity} × {product} at {price} each. {link}",
  "whatsapp.askStock": "Hi! Will you have {product} again? {link}",
  "banner.label": "Store highlights",
  "banner.slide": "{n} of {total}",
  "banner.prev": "Previous banner",
  "banner.next": "Next banner",
  "banner.goTo": "Go to banner {n}",
  "banner.pause": "Pause the banners",
  "banner.play": "Play the banners",
  "banner.presale": "Pre-sale",
  "banner.releases": "Out {date}",
  "product.presale": "Pre-sale",
  "product.presaleNote": "Pre-sale: out {date}. Pay now and we ship it as soon as it arrives.",
  "product.presaleNoteNoDate": "Pre-sale: pay now and we ship it as soon as it arrives.",
  "product.reserve": "Pre-order",
  "cart.presaleNote": "Your order includes pre-sale products: we ship it all together when they arrive. To get the rest sooner, place two orders.",
  "catalog.presaleOnly": "Pre-sales only",
  "home.newArrivals": "Just in",
  "home.newArrivalsAll": "See all new arrivals",
  "home.sets": "More sets",
  "home.setsCount": "{count} for sale",
  "home.setsAll": "See all sets ({count})",
  "home.sealed": "Sealed",
  "home.sealedAll": "See all",
  "home.sealed.packs": "Booster packs",
  "home.sealed.boxes": "Boxes, collections and decks",
  "home.sealed.etb": "Elite Trainer Boxes",
  "home.sealedEmpty": "Nobody is selling these right now. Check back soon.",
  "home.featured": "Featured",
  "home.byCategory": "Shop by category",
  "home.viewAll": "View all",
  "catalog.title": "Shop",
  "catalog.results": "{count} products",
  "catalog.results_one": "1 product",
  "catalog.empty": "No products match those filters.",
  "catalog.clearFilters": "Clear filters",
  "catalog.filters": "Filters",
  "catalog.showFilters": "Filter ({count})",
  "catalog.applyFilters": "Show results",
  "catalog.searchFor": "Results for “{q}”",
  "filters.game": "Game",
  "filters.category": "Category",
  "filters.price": "Price",
  "filters.set": "Set",
  "filters.setSearch": "Search a set (e.g. Surging, SSP)…",
  "filters.noMatches": "No matches",
  "filters.rarity": "Rarity",
  "filters.showAll": "Show all ({count})",
  "filters.showLess": "Show less",
  "filters.min": "Min",
  "filters.max": "Max",
  "filters.apply": "Apply",
  "filters.inStock": "Available only (store or sellers)",
  "filters.withOutOfStock": "Including out of stock",
  "filters.active": "Active filters",
  "filters.remove": "Remove filter: {label}",
  "sort.label": "Sort by",
  "sort.featured": "Featured",
  "sort.newest": "Newest",
  "sort.price_asc": "Price: low to high",
  "sort.price_desc": "Price: high to low",
  "sort.name_asc": "Name: A-Z",
  "pagination.label": "Pagination",
  "pagination.prev": "Previous",
  "pagination.next": "Next",
  "pagination.page": "Page {page}",
  "product.addToCart": "Add to cart",
  "product.added": "Added!",
  "product.outOfStock": "Out of stock",
  "product.lowStock": "Only {count} left!",
  "product.lowStock_one": "Only 1 left!",
  "product.inStock": "In stock",
  "product.quantity": "Quantity",
  "product.sku": "SKU",
  "product.language": "Language",
  "product.set": "Set",
  "product.number": "Number",
  "product.rarity": "Rarity",
  "product.condition": "Condition",
  "product.finish": "Finish",
  "product.contents": "What's inside",
  "product.setCards": "Cards you can pull",
  "product.setCardsIntro": "The {set} expansion has {count} cards. The most wanted ones on sale:",
  "product.setCardsIntroMany": "The {sets} expansions have {count} cards. The most wanted ones on sale:",
  "product.setCardsAll": "See the set's cards in the market",
  "product.related": "You may also like",
  "product.notFound": "We couldn't find this product.",
  "product.sale": "Sale",
  "product.back": "Back to shop",
  "product.backMarket": "Back to the market",
  "product.chooseOption": "Choose option",
  "product.from": "From",
  "product.transferPrice": "{price} by bank transfer",
  "product.version": "Version",
  "product.versionStock": "{count} available",
  "product.versionStock_one": "1 available",
  "printLang.es": "Spanish",
  "printLang.en": "English",
  "printLang.ja": "Japanese",
  "cart.title": "Your cart",
  "cart.empty": "Your cart is empty.",
  "cart.continue": "Continue shopping",
  "cart.subtotal": "Subtotal",
  "cart.checkout": "Checkout",
  "cart.remove": "Remove",
  "cart.decrease": "Decrease quantity",
  "cart.increase": "Increase quantity",
  "cart.items": "{count} items",
  "cart.items_one": "1 item",
  "cart.maxStock": "Max available: {count}",
  "cart.open": "Open cart ({count})",
  "checkout.title": "Checkout",
  "checkout.contact": "Contact details",
  "checkout.name": "Full name",
  "checkout.email": "Email",
  "checkout.phone": "Phone / WhatsApp",
  "checkout.city": "City / Province",
  "checkout.notes": "Notes (optional)",
  "checkout.delivery": "Delivery",
  "checkout.pickup": "Pickup at collection point",
  "checkout.shipping": "Home delivery",
  "checkout.pickupHint": "Free · {area}. We send you the address on WhatsApp after you buy.",
  "checkout.pickupNote": "After you pay we'll message you on WhatsApp with the exact address and pickup hours.",
  "checkout.address": "Delivery address (street, number, floor, postal code)",
  "checkout.errors.address": "Enter the delivery address.",
  "checkout.phoneHint": "We'll message you on WhatsApp at this number to arrange delivery.",
  "checkout.freeShipping": "Your order ships free! We dispatch it within {hours} hours.",
  "checkout.zone": "Delivery area",
  "checkout.zoneChoose": "Choose your area",
  "checkout.zoneFast": "Shipping {price}. We dispatch it within {hours} hours.",
  "checkout.zoneArrange": "to arrange",
  "checkout.subtotal": "Products",
  "checkout.shippingRow": "Shipping",
  "checkout.shippingChooseZone": "Choose the area",
  "checkout.shippingArrange": "Arranged on WhatsApp",
  "checkout.shippingFree": "Free",
  "checkout.zoneOther": "For your area we arrange the shipping (cost and timing) on WhatsApp.",
  "checkout.zoneOtherRate": "Shipping by post anywhere in Argentina: {price}. We send you the tracking number when it ships.",
  "checkout.freeFrom": "Free shipping on orders from {min}.",
  "checkout.errors.zone": "Choose the delivery area.",
  "checkout.errors.zoneMismatch": "That area doesn't match the city you chose: pick your city's area.",
  "checkout.steps": "Checkout steps",
  "checkout.step1": "Your details",
  "checkout.step2": "Shipping or pickup",
  "checkout.step3": "Payment",
  "checkout.continue": "Continue",
  "checkout.back": "Back",
  "checkout.emailHint": "We'll send the confirmation and your order link there.",
  "checkout.guestHint": "No account needed.",
  "checkout.guestLogin": "Have an account? Sign in to use your saved details.",
  "checkout.errors.openOrders": "You have several unpaid orders with this email. Pay one or let them expire before placing another.",
  "checkout.packaging": "Every card travels in a sleeve, and those over US$10 also in a rigid toploader, so they don't bend or get dirty.",
  "checkout.summary": "Order summary",
  "checkout.total": "Total",
  "checkout.submit": "Place order",
  "checkout.submitting": "Sending...",
  "checkout.successTitle": "Order received!",
  "checkout.successText": "Your order number is {number}. We'll contact you to arrange payment and delivery.",
  "checkout.errors.invalid": "Please check the form.",
  "checkout.errors.name": "Enter your name.",
  "checkout.errors.email": "Enter a valid email.",
  "checkout.errors.phone": "Enter a valid phone number.",
  "checkout.errors.city": "Enter your city.",
  "checkout.errors.delivery": "Choose a delivery method.",
  "checkout.errors.empty": "Your cart is empty.",
  "checkout.errors.tooMany": "Too many products in a single order.",
  "checkout.errors.items": "Your cart contains invalid products.",
  "checkout.errors.stock": "Some products no longer have enough stock. Please review your cart.",
  "checkout.errors.network": "We couldn't send your order. Please try again in a few minutes.",
  "error.generic": "Something went wrong. Please try again.",
  "error.retry": "Retry",
  "loading": "Loading...",
  "notFound.title": "Page not found",
  "notFound.back": "Back to home",
  "footer.rights": "© {year} pokefans.fun. All rights reserved.",
  "footer.disclaimer":
    "pokefans.fun is an independent store, not affiliated with The Pokémon Company. Pokémon and its names are trademarks of Nintendo, Creatures and GAME FREAK.",
  "footer.contact": "Contact",
  "footer.legal": "Legal",
  "footer.resources": "Resources",
  "footer.refunds": "Refund policy",
  "footer.withdraw": "Withdrawal button",
  "withdraw.title": "Withdrawal button",
  "withdraw.intro": "If you bought at pokefans.fun, you have 10 calendar days from receiving the product to withdraw from the purchase, without giving a reason (Argentine Law 24,240, art. 34). Fill in the form and you'll get a request code right away.",
  "withdraw.more": "We pay the return shipping and refund you through the same payment method. More in the",
  "withdraw.order": "Order number",
  "withdraw.orderHint": "It's in the confirmation email and in My account.",
  "withdraw.name": "Full name",
  "withdraw.email": "Email you bought with",
  "withdraw.phone": "Phone (optional)",
  "withdraw.reason": "Reason (optional)",
  "withdraw.submit": "Send withdrawal request",
  "withdraw.sending": "Sending…",
  "withdraw.doneTitle": "We received your withdrawal request",
  "withdraw.doneCode": "Your request code is:",
  "withdraw.doneText": "We also emailed it to you. We'll contact you within 48 hours with the return steps.",
  "withdraw.notFound": "We couldn't find an order with that number and email, but your request is registered: we'll check it and contact you.",
  "withdraw.errors.order": "Enter the order number.",
  "footer.consumer": "Consumer protection (Argentina): file a complaint here.",
  "legal.updated": "Last updated: {date}",
  "soon.pill": "Under construction",
  "soon.title": "Coming soon!",
  "soon.text": "We're building our shop for Pokémon TCG cards, boxes and accessories. You'll be able to buy online very soon.",
  "soon.point1": "Pokémon TCG singles and sealed product",
  "soon.point2": "Pay with Mercado Pago, card or PayPal",
  "soon.point3": "Nationwide shipping",
  "soon.cta": "Browse the market",
  "soon.strip": "The store isn't taking orders yet. Feel free to browse the catalog.",
  "soon.button": "Coming soon",
  "soon.previewTitle": "Preview mode",
  "soon.previewText": "You're seeing the full store as an invited tester; it isn't open to the public yet.",

  "auth.login": "Sign in",
  "auth.logout": "Sign out",
  "auth.account": "My account",
  "auth.loginTitle": "Sign in to your account",
  "auth.registerTitle": "Create your account",
  "auth.forgotTitle": "Recover your password",
  "auth.resetTitle": "Choose a new password",
  "auth.shopInviteTitle": "Choose your password to open your shop",
  "auth.name": "Name",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.newPassword": "New password",
  "auth.passwordHint": "At least 8 characters.",
  "auth.showPassword": "Show",
  "auth.hidePassword": "Hide",
  "auth.submitLogin": "Sign in",
  "auth.submitRegister": "Create account",
  "auth.submitForgot": "Send link",
  "auth.submitReset": "Save password",
  "auth.working": "Working...",
  "auth.google": "Continue with Google",
  "auth.or": "or",
  "auth.noAccount": "Don't have an account?",
  "auth.haveAccount": "Already have an account?",
  "auth.forgotLink": "Forgot your password?",
  "auth.backToLogin": "Back to sign in",
  "auth.checkEmailTitle": "Check your email",
  "auth.checkEmailText": "We sent a link to {email} to confirm your account. After that you can sign in.",
  "auth.forgotSent": "If an account exists for {email}, we sent you a link to reset your password.",
  "auth.resetDone": "Done, your password was updated. You can sign in now.",
  "auth.resendVerification": "Resend verification email",
  "auth.verificationResent": "We sent the verification email again.",
  "auth.errorSummary": "Please check the following:",
  "auth.errors.name": "Enter your name.",
  "auth.errors.email": "Enter a valid email.",
  "auth.errors.password": "Password must be at least 8 characters.",
  "auth.errors.invalidCredentials": "Wrong email or password.",
  "auth.errors.notVerified": "Please confirm your email before signing in.",
  "auth.errors.userExists": "An account with that email already exists: sign in with it (or reset your password).",
  "auth.errors.invalidToken": "This link is invalid or expired. Request a new one.",
  "auth.errors.tooMany": "Too many attempts. Wait a minute and try again.",
  "auth.errors.generic": "We couldn't complete that. Please try again.",
  "auth.marketingOptIn": "Email me about offers, restocks and price drops (I can unsubscribe at any time).",
  "auth.acceptTerms": "By creating an account you accept the",
  "auth.termsLink": "Terms and conditions",
  "auth.privacyLink": "Privacy policy",
  "profile.title": "My details",
  "profile.firstName": "First name",
  "profile.lastName": "Last name",
  "profile.phone": "Phone",
  "profile.address": "Delivery address",
  "profile.addressLine": "Street and number, floor, apartment",
  "profile.city": "City or town",
  "profile.province": "Province",
  "profile.postalCode": "Postal code",
  "profile.save": "Save my details",
  "profile.saved": "Your details were saved.",
  "profile.error": "We couldn't save. Please check your details.",
  "profile.avatar": "Profile picture",
  "profile.avatarChange": "Change picture",
  "profile.avatarRemove": "Remove picture",
  "profile.avatarError": "We couldn't use that image: try another JPG, PNG or WebP.",
  "profile.emails": "Emails",
  "profile.marketing": "Get emails about offers, restocks and price drops",
  "profile.marketingHint": "Emails about your orders and account still reach you.",
  "profile.errors.firstName": "Enter your first name.",
  "profile.errors.phone": "Enter a valid phone number.",
  "unsubscribe.title": "Unsubscribe from emails",
  "unsubscribe.text": "You'll stop getting offers and news. Emails about your orders will still reach you.",
  "unsubscribe.button": "Unsubscribe",
  "unsubscribe.done": "Done: we won't send you offer emails anymore. You can turn them back on in My account.",
  "unsubscribe.invalid": "This link is invalid or incomplete.",
  "address.province": "Province",
  "address.city": "City or town",
  "address.barrio": "Neighbourhood",
  "address.chooseProvince": "Type or choose the province",
  "address.provinceFirst": "Choose the province first",
  "address.typeCity": "Type to search",
  "address.noProvince": "There is no province with that name.",
  "address.noCity": "Not in the list: you can leave it typed as is.",
  "address.line1": "Street and number",
  "address.line2": "Floor, apartment, cross streets or other directions (optional)",
  "address.postalCode": "Postal code",
  "checkout.errors.place": "Choose the province and the city.",
  "watch.stock": "Let me know when it's back in stock",
  "watch.price": "Let me know if the price drops",
  "watch.stockOn": "We'll email you when it's back in stock.",
  "watch.priceOn": "We'll email you if the price drops.",
  "watch.priceOnTarget": "We'll email you if it drops to {price} or less.",
  "watch.cancel": "Cancel alert",
  "watch.targetLabel": "At what price? (optional, in US$)",
  "watch.targetPlaceholder": "Any drop",
  "watch.create": "Create alert",
  "watch.errors.target": "Enter a price below the current one (e.g. 12.50).",
  "watch.title": "My alerts",
  "watch.empty": "You have no alerts. On any product you can ask us to let you know when it's back in stock or its price drops.",
  "watch.kindStock": "When back in stock",
  "watch.kindPrice": "If the price drops",
  "watch.kindPriceTarget": "If it drops to {price}",
  "auth.twoFactor.needed": "Enter the code from your authenticator app.",
  "auth.twoFactor.invalid": "That code is invalid or expired. Try the new one.",
  "auth.twoFactor.title": "Two-step verification",
  "auth.twoFactor.code": "6-digit code",
  "auth.twoFactor.backupCode": "Backup code",
  "auth.twoFactor.useBackup": "Use a backup code",
  "auth.twoFactor.useApp": "Use the authenticator app",
  "auth.twoFactor.trust": "Trust this device for 30 days",
  "auth.twoFactor.submit": "Verify",
  "auth.errors.google": "We couldn't sign you in with Google. Please try again.",
  "auth.errors.comingSoon": "We're not open yet: only test accounts can sign in for now.",
  "auth.errors.invitesOnly": "The store isn't open yet: only invited accounts can sign in for now.",
  "account.title": "My account",
  "account.hello": "Hi, {name}",
  "account.orders": "My orders",
  "cards.title": "My collection",
  "cards.level": "Level {level} of {max}",
  "cards.levelShort": "Level {level}",
  "cards.generation": "Generation {gen}",
  "cards.chooseTitle": "Choose your starter Pokémon",
  "cards.chooseIntro": "Your avatar is a real card that evolves: every milestone (verifying your email, your first purchase, free shipping…) takes it up a level and makes it rarer, all the way to gold.",
  "cards.changeIntro": "Pick another starter: you keep your level, the cards change.",
  "cards.picking": "Choosing…",
  "cards.pickError": "Could not save it. Please try again.",
  "cards.later": "Later",
  "cards.cancel": "Cancel",
  "cards.evolving": "What? Your card is evolving!",
  "cards.levelUp": "You reached level {level}!",
  "cards.great": "Great!",
  "cards.useCard": "Use my card as avatar",
  "cards.usePhoto": "Use my photo",
  "cards.useLatest": "Always use the latest",
  "cards.useThis": "Use as avatar",
  "cards.changeStarter": "Change starter",
  "cards.locked": "Level {level}: locked",
  "cards.milestones": "Milestones: {done} of {total}",
  "cards.done": "done",
  "account.noOrders": "You haven't placed any orders yet.",
  "account.viewOrder": "View order",
  "checkout.accountEmail": "We'll use your account email: {email}",
  "checkout.payment": "Payment method",
  "checkout.pay.mercadopago": "Mercado Pago",
  "checkout.pay.mercadopagoHint": "Cards, account balance and more. Charged in Argentine pesos: {amount}.",
  "checkout.pay.stripe": "Credit or debit card (Stripe)",
  "checkout.pay.stripeHint": "Charged in US dollars: {amount}.",
  "checkout.pay.paypal": "PayPal",
  "checkout.pay.paypalHint": "Charged in US dollars: {amount}.",
  "checkout.pay.transfer": "Bank transfer (Argentina)",
  "checkout.pay.transferHint": "Special price without Mercado Pago's fee: you pay {amount}. Send the receipt on WhatsApp; we hold the stock for 2 hours.",
  "checkout.pay.crypto": "Crypto (USDT)",
  "checkout.pay.cryptoHint": "{discount}% off: you pay {amount} in USDT. Send the receipt on WhatsApp; we hold the stock for 2 hours.",
  "order.manual.title": "How to pay",
  "order.manual.intro": "We reserved your products until {deadline}. Pay with these details:",
  "order.manual.amount": "Exact amount",
  "order.manual.holder": "Account holder",
  "order.manual.bank": "Bank",
  "order.manual.network": "Network",
  "order.manual.networkWarn": "Send only on the network shown: a transfer on another network is lost.",
  "order.manual.discount": "Includes the {discount}% discount.",
  "order.manual.transferPrice": "It is the special bank-transfer price (without Mercado Pago's fee).",
  "order.manual.send": "Once you pay, send us the receipt on WhatsApp with your order number. We'll confirm the payment and email you.",
  "order.manual.sendEmail": "Once you pay, send us the receipt by replying to the email we sent you, with your order number.",
  "order.manual.whatsapp": "Send the receipt on WhatsApp",
  "order.manual.copy": "Copy",
  "order.manual.copied": "Copied",
  "order.manual.expired": "The reservation expired. If you already paid, send us the receipt anyway and we'll check it.",
  "checkout.pay.none": "No payment methods are available right now.",
  "order.coupon": "Coupon {code}",
  "checkout.coupon.label": "Got a coupon?",
  "checkout.coupon.apply": "Apply",
  "checkout.coupon.remove": "Remove coupon",
  "checkout.coupon.applied": "Coupon {code}: {amount} off",
  "checkout.coupon.someExcluded": "It doesn't apply to some products in your cart.",
  "checkout.coupon.invalid": "That code isn't valid.",
  "checkout.coupon.not_found": "We couldn't find that coupon.",
  "checkout.coupon.inactive": "That coupon is no longer active.",
  "checkout.coupon.not_started": "That coupon hasn't started yet.",
  "checkout.coupon.expired": "That coupon has expired.",
  "checkout.coupon.exhausted": "That coupon has been used up.",
  "checkout.coupon.already_used": "You already used this coupon.",
  "checkout.coupon.personal": "This code is personal: it only works on the account that received it.",
  "checkout.coupon.email": "Fill in your email in step 1 to use a coupon.",
  "checkout.coupon.not_applicable": "That coupon doesn't apply to the products in your cart.",
  "checkout.coupon.min_not_reached": "Your order doesn't reach this coupon's minimum.",
  "checkout.pay.arsNote": "In pesos: dólar blue ({rate}) + 5% with Mercado Pago; by bank transfer, without Mercado Pago's fee.",
  "checkout.chargedAs": "You pay: {amount}",
  "checkout.submitPay": "Continue to payment",
  "checkout.redirecting": "Taking you to the payment page...",
  "checkout.errors.payment": "Choose a payment method.",
  "checkout.errors.paymentProvider": "We couldn't start the payment. Please try another method.",
  "order.title": "Order {number}",
  "order.status.unpaid": "Waiting for payment",
  "order.status.pending": "Payment processing",
  "order.status.paid": "Payment approved!",
  "order.status.failed": "Payment not completed",
  "order.status.expired": "Reservation expired",
  "order.status.refunded": "Payment refunded",
  "order.text.unpaid": "We haven't received the payment confirmation yet. If you already paid, wait a few seconds.",
  "order.text.manual": "We're waiting for your payment. Once you send the receipt and we confirm it, we'll email you.",
  "order.text.pending": "The payment provider is processing it. We'll email you once it clears.",
  "order.text.paid": "Thanks for your purchase. We'll contact you to arrange delivery.",
  "order.text.failed": "The payment was declined or cancelled. The products went back into stock.",
  "order.text.expired": "{minutes} minutes passed without payment, so we released the products.",
  "order.text.refunded": "The payment was refunded.",
  "order.cancelled": "You cancelled the payment. You can try again from the shop.",
  "order.charged": "Charged: {amount}",
  "order.payAgain": "Back to the shop",
  "order.accountTitle": "Create an account?",
  "order.accountText": "With your email {email}, in a minute. This order shows up in your account as soon as you verify it.",
  "order.accountPerk1": "Follow all your orders from My account.",
  "order.accountPerk2": "Your details and address are saved for next time.",
  "order.accountPerk3": "Subscribe to our news and get {pct}% off your next order.",
  "order.accountCta": "Create my account",
  "order.accountHave": "I already have an account",
  "order.guestNote": "We emailed you everything. To see your orders anytime, sign in with the account you bought with.",
  "order.checking": "Checking payment...",
  "order.date": "Date",
  "order.items": "Products",

  "identificar_titulo": "Identify card",
  "identificar_desc": "Take a photo of the card to search the catalog.",
  "abrir_camara": "Open camera",
  "subir_foto": "Upload photo",
  "install.title": "Install pokefans",
  "install.body": "Open it as an app from your home screen.",
  "install.ios": "Tap Share, then \"Add to Home Screen\".",
  "install.button": "Install",
  "sacar_foto": "Take photo",
  "cancelar": "Cancel",
  "identificar_accion": "Identify card",
  "buscando": "Searching…",
  "tomar_otra": "Take another",
  "procesando": "Processing image…",
  "resultados": "Results",
  ...marketEn,
  ...buyEn,
  ...wantedEn,
};

export const messages = { es, en } as const;
